// extracted by mini-css-extract-plugin
export default {"root":"ControlPanel-root-727d928739bd8a4d15a0e6e026baa9c5"};